module.exports = require("./mgh");